<template>
  <ion-row>
    <ion-col size="auto">
      <ion-label class="required-label">{{props.label}}</ion-label>
    </ion-col>
    <ion-col size="auto">
      <ion-badge :class="['field-badge', props.required ? 'field-badge-required' : 'field-badge-optional']">
        {{ props.required ? '必須' : '任意' }}
      </ion-badge>
    </ion-col>
  </ion-row>
</template>


<script setup lang="ts">
const props = withDefaults(defineProps<{
  value?: string,
  label?: string,
  required?: boolean
}>(), {
  value: '',
  label: '',
  required: true
});
</script>

<style scoped>
.field-badge {
 color: white;
 font-weight: bold;
 font-size: max(13px, 0.8125rem);
 padding: 5px 8px;
 border-radius: 10px;
}
.field-badge-required {
 background-color: #FF0000;
}
.field-badge-optional {
 background-color: #8C8C8C;
}
.required-label {
 font-weight: 900;
}
</style>
